const keyName = "notpSetting";
export const SettingProperties = ["useCache"];

function getSetting() {
    if (window.localStorage) {
        return JSON.parse(localStorage.getItem(keyName));
    }
    return null;
}

function saveSetting(saveObj) {
    if (window.localStorage) {
        localStorage.setItem(keyName, JSON.stringify(saveObj));
        return true;
    }
    return false;
}

export default { getSetting, saveSetting };


// WEBPACK FOOTER //
// ./src/views/setting/systemSetting.js